import { instance } from "@/lib/axios/instance";

export type CaptainModel = {
  id: string;
  name: string;
  contextLength: number | null;
};

export async function fetchCaptainModels(): Promise<CaptainModel[]> {
  const { data } = await instance.get<CaptainModel[]>(
    "/api/v2/captain/models",
  );
  return data ?? [];
}
